import { Box, Typography } from "@mui/material";
import LoadingIcon from "../../../../../../components/LoadingIcon";

import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import { entityKeys } from "../../../../../../api/queryKeys";
import { ArrowButton } from "../shared/ArrowButton";
import EntitiesChipList from "./EntitiesChipList";
import MisconfiguredEntitiesSection from "./MisconfiguredEntitiesSection";

/*
- This component is used for all places except the control drawer
- It uses a table with entity type tabs, but with no included/excluded tabs
- It supports complex entities only
*/
export default function RelatedEntitiesSection({
  complexEntitiesByType,
  showDetailedAffectedEntities,
  setShowDetailedAffectedEntities,
}) {
  const colors = useColors();
  const { getTerminatedUsersAndHosts, trackEvent } = useAPI();
  const hasEntitiesAtRisk = Object.keys(complexEntitiesByType ?? {}).length > 0;
  const [selectedEntityTypeTab, setSelectedEntityTypeTab] = useState(null);

  const handleChipClick = (entityType) => {
    trackEvent(`User clicked the ${entityType} affected entities chip`);
    setSelectedEntityTypeTab(entityType);
    setShowDetailedAffectedEntities(true);
  };

  const handleViewAllClick = () => {
    trackEvent(`User clicked the "view all affected entities" button`);
    const firstEntityType = Object.keys(complexEntitiesByType)[0];
    setSelectedEntityTypeTab(firstEntityType);
    setShowDetailedAffectedEntities(true);
  };

  const handleBackClick = () => {
    trackEvent(
      `User clicked the "back to overview" button from the affected entities`
    );
    setSelectedEntityTypeTab(null);
    setShowDetailedAffectedEntities(false);
  };

  const terminatedEntitiesQuery = useQuery({
    queryKey: entityKeys.terminatedEntities(),
    queryFn: getTerminatedUsersAndHosts,

    select: (response) => response?.data,
  });

  return (
    <>
      {terminatedEntitiesQuery.isLoading ? (
        <LoadingIcon size={22} />
      ) : terminatedEntitiesQuery.isSuccess ? (
        showDetailedAffectedEntities ? (
          <Box display="flex" flexDirection="column" height="68px" gap={3}>
            <ArrowButton
              text="Back to Overview"
              onClick={handleBackClick}
              forward={false}
            />
            <Typography
              variant="subtitle1"
              color={colors.primary}
              lineHeight="20px"
            >
              Affected Entities
            </Typography>
            <MisconfiguredEntitiesSection
              entitiesByType={complexEntitiesByType}
              showDetailedAffectedEntities={showDetailedAffectedEntities}
              selectedEntityTypeTab={selectedEntityTypeTab}
              setSelectedEntityTypeTab={setSelectedEntityTypeTab}
            />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" height="68px" gap={2}>
            <Typography
              variant="subtitle1"
              color={colors.primary}
              lineHeight="20px"
            >
              What entities are at risk?
            </Typography>
            {hasEntitiesAtRisk ? (
              <Box
                display="flex"
                justifyContent="space-between"
                height="32px"
                alignItems="center"
              >
                <EntitiesChipList
                  entitiesByType={complexEntitiesByType}
                  handleChipClick={handleChipClick}
                />
                <ArrowButton
                  text="View all entities"
                  onClick={handleViewAllClick}
                />
              </Box>
            ) : (
              <Typography variant="caption" color={colors.primary}>
                No entities at risk
              </Typography>
            )}
          </Box>
        )
      ) : null}
    </>
  );
}
